{
  "clearButtonAriaLabel": "Fjern filter"
}
